<template>
  <base-modal :show="show"
              @close="closeWebsiteSettings"
              size="small">
  <div class="blocking-alert">
    <div class="blocked-url one-liner">{{ blockedUrl }}</div>
    <div class="blocking-message">
      {{ $t("alerts.blockUrlAlert", { domain }) }}
    </div>
    <div class="btn-group">
      <div class="btn btn-cancel"
           @click="$emit('cancel')">
        {{ $t("cancel") }}
      </div>
      <div class="btn btn-confirm"
           @click="$emit('confirm')">
        {{ $t("ok") }}
      </div>
    </div>
  </div>
  </base-modal>
</template>

<script>
  import { getDomain } from '@/services/utils.js'

  export default {
    props: {
      show: {
        type: Boolean,
        required: true
      },

      blockedUrl: {
        type: String,
        required: true
      }
    },

    computed: {
      domain() {
        return getDomain(this.blockedUrl)
      }
    },

    methods: {
      closeWebsiteSettings() {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .blocking-alert {

    .blocking-message {
      font-size: 12px;
      margin: 12px 0 30px 0;
    }

    .btn-group {
      display: flex;
      justify-content: center;
      align-items: center;

      margin: 0 10px 0 10px;
      font-size: 12px;

      .btn {
        width: 60px;
        height: 25px;

        border-radius: 2px;
        padding: 7px 0;
        margin-right: 12px;

        color: #fff;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
      }

      .btn-confirm {
        background: #22c883;
      }

      .btn-cancel {
        background: #f35f5f;
      }
    }
  }
</style>
